export const Accounts = {
  SAVINGS: 'SAVINGS',
  TRANSFERS: 'TRANSFERS',
  LOAN: 'LOAN',
  CLIENT: 'CLIENT',
  CORPORATE: 'CORPORATE',
} as const;

export type AccountType =
  (typeof Accounts)[keyof typeof Accounts];
